module.exports = __webpack_public_path__ + "img/mostly-cloudy-storm.dd2bc24.svg";